
import Vue from 'vue';
import VueRouter from 'vue-router';
import api from '@js/api';
import routes from './routes';

Vue.use(VueRouter);

export const router = new VueRouter({
	mode: 'history',
	routes
});

// Set page title from meta
router.beforeEach((to, from, next) => {
    let hasTTId = null;
    hasTTId = (!Object.keys(to.query).length && from.query.tt_id);

    const determineNext = () => {
        const nextPayload = {
            name: to.name,
            query: { ...to.query, ...from.query },
            params: to.params
        };

        return hasTTId ? next(nextPayload) : next();
    }

    if (from.matched.length < 1) {
        return determineNext();
    }

    const defaultTitle = 'Sculptnation - My Account';
    document.title = to.meta.title || defaultTitle;

    api.trackPageClick(to.path);

    determineNext();
});

export default router;
